/* eslint max-len: off */
// TODO: Need translation!
// zh-CN
export default {
  // TODO: i18n
  choice_page: {
    options: {
      partner: 'AMEX Session',
      partner_2: 'Swire Session',
      partner_3: 'TX Session',
      public_audience: 'Public Session',
      vip: 'VIP Session',
    },
  },    
  form_entry_page: {
    title: "展览日程",
    options: {
      salutations: {
        ms: '小姐',
        mrs: '太太',
        mr: '先生'
      },
    },
    section1: {
      title: "选择日期"
    },
    section2: {
      title: "选择时段"
    },
    section3: {
      title: "个人资料",
      fields: {
        title: '称呼',
        first_name: '名 *',
        last_name: '姓 *',
        phone: '手机号码 *',
        email: '电邮',
        age_group: '年龄',
        agree: '本人已阅读丶了解并同意所提供的资料可按照<u>收集个人资料声明</u>及有关活动的<u>条款及细则</u>而持有和使用。',
        agree_guests: '请确保该贵宾已同意您使用他/她的个人资料。I.T 只会使用该资料作活动登记，并不会用作其他用途。',
        rsvp_agree_terms: 'Subscribe to newsletter', // TODO: i18n
      },
      required: '* 必须填写',
      buttons: {
        submit: "提交"
      }
    },
    reservation_details: {
      title: "预约"
    },
    modals: {
      // cancel_timeslot: {
      //   title: '取消预约',
      //   body: `
      //     如你想更改预约,请按返回并于上表重新选择日期及时段。<br />
      //     <br />
      //     如你想取消预约,请按确定。
      //   `,
      //   buttons: {
      //     yes: '确定',
      //     no: '返回',
      //   },
      // },
      change_timeslot: {
        title: '更改预约',
        body: '确定更改预约？',
        buttons: {
          yes: '确认',
          no: '取消',
        },
      },
      terms_and_conditions: {
        body: `
        <h2>隐私政策</h2>
        <p>
          敬爱的用户，I.T非常注重保护用户个人信息，故在此我们诚挚地提醒您：在您使用I.T提供的服务时，我们将按照本隐私权政策收集、存储及使用您的个人信息。本隐私权政策包含了我们收集、存储、使用您的个人信息的目的、方式及范围，同时向您清晰地介绍了我们对您个人信息的处理及保护方式。因此，完整地阅读本隐私权政策可以帮助您了解自己在使用I.T服务时的隐私权范围及限制。如您不同意本隐私权政策的任何内容，您应立即停止使用I.T服务。当您使用I.T提供的任一服务时，即表示您已同意我们按照本隐私权政策来合法使用和保护您的个人信息。如您对本隐私权政策有任何疑问，您可通过I.T公布的联系方式与我们联系。
        </p>
        <strong>一、适用范围</strong>
        <p>
          本隐私权政策适用于I.T提供的所有服务，包括但不限于I.T网站及/或登陆相关其它客户端使用I.T提供的服务。但本隐私权政策不适用于其他任何第三方向您提供的服务，例如用户通过第三方支付软件或网上银行进行支付时所向该第三方提供的信息不适用于本隐私权政策。
        </p>
        <strong>二、收集信息的目的</strong>
        <p>
          I.T收集个人信息的目的是为用户提供尽可能更优的个性化服务，并且不断提升用户购物体验。未经用户合法授权，I.T不会主动公开、编辑或透露用户的个人信息及用户保存在I.T中的非公开内容（包括但不限于用户与I.T之间的往来电邮），除非出现有下列情况：
          <br>1、根据有关法律法规规定、政府机关要求或其他合法服务程序规定而公开个人信息的。
          <br>2. 在紧急情况下，为维护用户及公众的权益而公开个人信息的。
          <br>3. 为维护I.T的知识产权或其它合法权益而公开个人信息的。
          <br>4. 其它依法需要公开、编辑或透露个人信息的情况。
        </p>
        <strong>三、收集信息的范围及方式</strong>
        <p>
          在用户使用I.T的服务过程中，为了准确、完善地提供相应服务并匹配用户的个性化选择，I.T会通过按以下方式采集并存储如下种类信息：
          <br>1、用户向我们提供的信息。当用户注册I.T及您在使用I.T提供的服务时提交的信息。该些信息包括但不限于用户的姓名、性别、出生年月日、身份证号码、护照姓、护照名、护照号码、电话号码、电子邮箱、地址及相关附加信息（如您所在的省份和城市、邮政编码等）。
          <br>2、用户服务使用相关信息。在您使用I.T服务时，I.T自动接收并记录的用户浏览器和计算机上的信息，包括但不限于用户的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及用户需求的网页记录等数据。当用户访问I.T电商网站时，可以通过Cookie更加方便地进行浏览。Cookie并不会侵害用户隐私，但若用户对此有所疑虑，则可将浏览器设定为禁止Cookie，但若设定为禁止Cookie，用户或许不能正常使用I.T电商网站的某些功能。
          <br>3、从其他来源获得的信息。除上述信息外，I.T还可能为了及时跟进、改进服务质量的合理需要而收集其他用户信息，包括但不限于用户与我们的客户服务团队联系时所提供的相关信息、用户参与问卷调查时向I.T发送的问卷答复等。   烦请了解并同意，任何违反中华人民共和国法律法规规定或违反I.T其他条款和协议的相关信息不适用本隐私权政策的保护。
        </p>
        <strong>四、信息使用</strong>
        <p>
          I.T会把用户信息用于以下几种情况：
          <br>1、I.T会向用户提供其所选择使用的各项服务，并维护、改进这些服务。
          <br>2、I.T会向用户推荐并发送关于I.T不同货品和服务信息或者I.T认为用户会感兴趣的其它货品和服务。如果用户不希望收到这样的信息，只需按照I.T公布的操作流程和提示进行退订即可。
          <br>3、I.T可能使用外部服务供应商提供的服务而更好的为用户带来良好的用户体验。I.T会通过协议或技术措施，保证该些供应商将能够接触到履行其职责和义务所需要的用户个人信息，但不能将此信息用于其它的目的。
          <br>4、I.T可能使用用户个人信息以预防、发现或调查有关网络欺诈、危害安全、非法或违反与I.T及其关联方协议、政策或规则的行为，以保护用户、I.T及/或其关联方的合法权益。
          <br>5、经用户许可的其他用途。
        </p>
        <strong>五、信息更正</strong>
        <p>
          如用户发现I.T收集、存储的其个人信息有错误的，用户有权要求I.T予以更正，其可通过I.T上的相应操作程序自主修改或联系I.T公布的客户服务部门进行更改。I.T会采取相应措施在第一时间与用户确认并予以修正。
        </p>
        <strong>六、信息存储及保护</strong>
        <p>
          I.T收集的有关用户的信息和资料将保存在I.T及/或其关联公司的服务器上，这些信息和资料也可能传送至用户所在国家、地区或I.T收集信息和资料所在地依照当地法律法规要求被访问、存储和展示。  I.T保留用户的个人数据的时间只限于法律规定的和为用户提供服务的时间。在此之后I.T会删除用户的个人数据。 为保障用户的信息安全，I.T努力采取各种合理的物理、电子和管理方面的安全措施来保护用户信息，使免受泄漏、毁损或者丢失的风险。该些措施包括但不限于SSL、信息加密存储、数据中心的访问控制；用户的账户均有安全保护功能，I.T将通过向其它服务器备份、对用户密码进行加密等安全措施确保用户的信息不丢失，不被滥用和篡改；I.T对可能接触到用户的信息的员工或外包人员也采取了严格的管理措施，包括但不限于根据岗位职能控制相应权限、签署保密协议、监控员工操作情况等。 在发生或者可能发生用户信息泄露、毁损、丢失的情况时，I.T会立即采取相应的补救措施，按照相关法律规定及时告知用户并向有关主管部门报告。
        </p>
        <strong>七、责任限制</strong>
        <p>
          除《服务使用协议》中列明的免责声明外，下列情况I.T亦毋需承担任何责任：
          <br>1、由于用户本人将其密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露；
          <br>2、任何由于黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营的不可抗力事件而造成的个人资料泄露、丢失、被盗用或被篡改等。
        </p>
        <strong>八、举报</strong>
        <p>
          用户在I.T上，不得发布法律、法规所禁止发布或者传输的信息、不得有泄露他人身份、散布他人隐私等侵害他人合法权益的行为。如I.T发现有用户有上述行为，I.T有权立即停止传输该信息并采取消除等处置措施，保存有关记录，并向有关主管部门报告。 如用户发现他人存在上述行为或在I.T发现任何网络安全隐患且有合理理由相信其个人信息已经或将要受到侵犯，用户可通过I.T公布的联系方式向I.T进行信息安全投诉、举报。I.T公布的联系方式与将会在第一时间受理并处理。
        </p>
        <strong>九、拒绝提供信息的后果</strong>
        <p>
          I.T非常尊重用户的选择，用户在I.T上进行操作时，可拒绝提供部分个人信息。但是，这会影响到用户体验，用户将不能够完整地体验到I.T提供的部分服务。
        </p>
        <strong>十、未成年人保护</strong>
        <p>
          I.T重视未成年人的个人信息保护，如用户为未成年人（未满十八周岁），I.T要求其监护人仔细阅读本隐私权政策，并在征得该监护人同意的前提下使用I.T的服务或向I.T提供信息。
        </p>
        <strong>十一、通知和修订</strong>
        <p>
          根据I.T的业务的时常变化，隐私权政策也将随之进行不时修订。I.T会通过电子邮件方式、在I.T电商网站上发出更新版本提示或其他方式提醒用户的相关更新情况。除另有声明外，现行的隐私权政策适用于I.T所有用户和用户账户的所有信息。
        </p>
        <p>
          I.T版本生效日期：2017年8月1日
        </p>
        `,
        buttons: {
          close: "关闭"
        }
      },
      accept_terms: {
        body: "",
        buttons: {
          accept: '同意',
        }
      }
    }
  },
  home_page: {
    title: "Home",
    section_title: "立即登记",
    message: "Reserve your slot lorem ipsum dolor sit amet, consectetu",
    button: "立即预约"
  },
  login_page: {
    title: '用手机号码登记或直接登入',
    sms_code_message: 'Enter SMS verification code sent to {{mobile_number}}',
    did_not_receive_code: '未接收到验证码？',
    fields: {
      mobile_number: '手机号码',
      sms_code: '短信验证码',
    },
    buttons: {
      get_verification_code: '获取验证码',
      resend_code: '重新获取',
      submit: '提交',
    },
  },
  complete_page: {
    main_title: "Confirmed",
    title: {
      one: "感谢登记，期待您的光临！",
      other: "已成功预约该时段，详情将以短信形式发送给您。",
      zero: "请出示该二维码进入会场"
    },
    message: "您已成功预约 I.T 30 周年展览。<br />请留意我们发出的短信更新。",
    alt_qrcode_message: "请出示该二维码进入会场",
    reservation: {
      title: '你的预约',
      venue_address: "香港太古广场 L1 楼 xxxx 号店铺",
      labels: {
        name: "姓名",
        mobile: "手机号码",
        email: "电邮地址",
        date: "预约场次: {{type}}",
        venue: "活动地址",
        expired: "Expired",
        used: "Attended"
      }
    },
    buttons: {
      change_timeslot: "更改预约"
    },
    did_not_receive_sms: {
      title: "未收到短信？",
      message:
        "假如您在预约过程中遇到任何问题，请致电 I.T 顾客服务热线 3144 0111。",
      button: "重新发送"
    },
    modals: {
      // resend_sms: {
      //   title: '感谢你的登记',
      //   body: '确认短讯已发送至你登记的电话号码。',
      //   button: '好',
      // },
      change_reservation: {
        title: '更改预约',
        body: '确定更改预约？',
        buttons: {
          yes: '确认',
          no: '取消',
        },
      },
    }
  },
  no_more_sessions_page: {
    title: '谢谢！',
    body: `
      <br />
      已成功预约
    `,
  },
  event_closed_page: {
    title: '谢谢！',
    body: `
      <br />
      已成功预约
    `, // TODO: i18n
  },
  rsvp_closed_page: {
    title: '谢谢！',
    body: `
      <br />
      已成功预约
    `,
  },
  it_rsvp_30th_anniv: {
    event_details: {
      title: "I.T 30 周年展览",
      description_1: "为庆祝 I.T 成立 30 周年，我们诚邀您出席这一革新的全电子化展览，亲身感受时装与科技的融合。",
      description_2: "展览概念融合 see-now-buy-now 的时尚趋势，配合一系列数码展示亭，发表首次曝光的 I.T 30 周年线上独家商品，让您现场体验全方位数码购物服务。",
      description_3: "立即登记优先体验。",
      address: "香港太古广场 L1 楼 xxxx 号店铺",
      date: "2018 年 10 月 26 日 至 28 日"
    },
    early_access: {
      title: "商品详情",
      description:
        "[CN] Once registered for the event, you’ll get access to a sneak peak of our upcoming anniversary exclusive collection."
    },
    footer: {
      title: "EARLY ACCESS",
      description:
        "Once registered for the event, you’ll get access to a sneak peak of our upcoming anniversary exclusive collection.",
      link_data: {
        email: {
          label: "itrsvp@ithk.com",
          url: "mailto:itrsvp@ithk.com"
        },
        phone: {
          label: "+852&nbsp;3144&nbsp;0111 (10am&nbsp;-&nbsp;9pm&nbsp;/&nbsp;Mon&nbsp;-&nbsp;Fri)",
          url: "tel:+85231440111"
        },        
        privacy: {
          label: "Privacy Policy",
          url: "https://hk.iteshop.com/b_it/help/privacy-policy"
        },
        legal: {
          label: "Terms & Conditions",
          url: "https://hk.iteshop.com/b_it/help/terms-of-use"
        }
      }
    },
    language_switcher: {
      title: '选择语言',
      button: {
        en_label: 'English',
        cn_label: '中文'
      }
    },
    app_header: {
      title: 'I.T 30 周年展览'
    }
  }
};



// WEBPACK FOOTER //
// ./src/locales/zh-CN.js